import { KeyboardArrowDown } from '@mui/icons-material'
import { PlanPurchaseExperienceContext } from '../PlanPurchaseExperienceContext'
import { useContext, useState } from 'react'
import PromoCodeInput from '@dtx-company/app/shared/code/src/components/upgrade/PromoCodeInput'
import { Button } from '@dtx-company/design-system/src'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'

export const PromoCode = (): JSX.Element => {
  const { promoCodeState } = useContext(PlanPurchaseExperienceContext)
  const [showPromotion, setShowPromotion] = useState(false)

  const showPromoCodeField = showPromotion || promoCodeState.wasLoadedFromQuery
  return (
    <>
      {!showPromoCodeField ? (
        <Button
          variant="text"
          color="tertiary"
          onClick={() => {
            setShowPromotion(prevShowPromotion => !prevShowPromotion)
            fireAnalyticsEvent('Revenue_Upgrade_Clicked_PromoCodeDropdown')
          }}
          endIcon={KeyboardArrowDown}
        >
          Enter promotion code
        </Button>
      ) : (
        <PromoCodeInput
          promoCode={promoCodeState.promoCode}
          setPromoCode={promoCodeState.setPromoCode}
          state={promoCodeState.state}
          onApply={promoCodeState.validatePromoCodeAndSet}
        />
      )}
    </>
  )
}
